/* eslint-disable */
const bookList = () => import('./pages/book-list');
const full = () => import(/* webpackChunkName: "full" */'./pages/full');
const chapter = () => import(/* webpackChunkName: "full" */'./pages/chapter');
const catalog = () => import(/* webpackChunkName: "full" */'./pages/catalog-modal');
// import catalog from './pages/catalog-modal';
export default [{
	name: 'book-list',
	path: '/textbook/list/:page',
	component: bookList,
	children: [{
		name: 'book-list-catalog',
		path: 'catalog',
		component: catalog
	}]
  
}, {
	path: '/textbook/full/:page',
	component: full,
	children: [{
		path: '',
		component: chapter
	}, {
		name: 'book-chapter',
		path: ':resource_id',
		component: chapter
	}, {
		name: 'book-catalog',
		path: ':resource_id/catalog',
		components: {
			default: chapter,
			catalog
		}
	}]
}];



// WEBPACK FOOTER //
// ./src/modules/textbook/routes.js